import React, { PureComponent, Fragment } from "react";
import { PropTypes } from "prop-types";
import { Form, Input } from "semantic-ui-react";

import FormikAPIErrorMessage from "./FormikAPIErrorMessage.jsx";

import { getErrorStateFromProps } from "../formUtils.js";

class FormikSemanticSlider extends PureComponent {
  static propTypes = {
    field: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    apiErrors: PropTypes.object,
    label: PropTypes.string,
    placeholder: PropTypes.string
  };

  static defaultProps = {
    min: 0,
    max: 5,
    step: 1,
    readOnly: false,
    required: false
  };

  static CHANGE_DELAY = 2000;

  state = {
    value: 0
  };

  // -- HANDLERS -- //

  setAllFieldValues = value => {
    const {
      size,
      count,
      chunk,
      field: { name },
      form: { setFieldValue }
    } = this.props;

    if (name) {
      setFieldValue(name, value);
    }

    if (size) {
      const sizeValue = chunk < 1 ? value : chunk;
      setFieldValue(size, sizeValue);
    }

    if (count) {
      const countValue = chunk < 1 ? 1 : value / chunk;
      setFieldValue(count, countValue);
    }
  };

  onRangeChange = (evt, { value }) => {
    const {
      form: { setFieldValue }
    } = this.props;

    const valueAsInt = parseInt(value, 10);

    // we set fields here to keep slider moving
    // doDelayedChange rounds the final value at rest for use
    setFieldValue("ignoreChangeInSideEffect", true);
    this.setAllFieldValues(valueAsInt);

    this.setState({ value: valueAsInt });
    this.doDelayedChange();
  };

  onRangeBlur = evt => {
    const {
      field: { name },
      form: { setFieldTouched }
    } = this.props;
    setFieldTouched(name, true);

    // apply change immediately rather than waiting for doDelayedChange
    this.doChange();
  };

  doDelayedChange = () => {
    clearTimeout(this.changeDelayTimer);
    this.changeDelayTimer = setTimeout(
      this.doChange,
      FormikSemanticSlider.CHANGE_DELAY
    );
  };

  doChange = evt => {
    const {
      field: { name },
      form: { setFieldValue }
    } = this.props;

    const boundedValue = this.boundValue(this.state.value);

    this.setAllFieldValues(boundedValue);

    setFieldValue("ignoreChangeInSideEffect", false);
  };

  // -- UTILS -- //

  boundValue = value => {
    const { min, max, step } = this.props;

    let boundedValue = !value || value < min ? min : value;
    boundedValue = boundedValue > max ? max : boundedValue;

    return Math.round(parseInt(boundedValue, 10) / step) * step;
  };

  render() {
    const { field, apiErrors, label, min, max, step, readOnly, required } =
      this.props;

    // set semantic-ui field error state
    const isError = getErrorStateFromProps(this.props);

    // needed to adjust field margin-bottom if error is shown
    const className = isError
      ? "formik-slider-input errored"
      : "formik-slider-input";

    // props for both input fields
    const inputProps = {
      readOnly,
      onChange: readOnly ? null : this.onRangeChange,
      onBlur: readOnly ? null : this.onRangeBlur,
      disabled: readOnly
    };

    return (
      <Fragment>
        <Form.Input
          {...field}
          {...inputProps}
          value={!Number.isNaN(field.value) ? field.value : 0}
          label={label}
          min={min}
          max={max}
          step={step}
          type="range"
          required={required}
          className={className}
        />
        <Input
          {...field}
          {...inputProps}
          value={!Number.isNaN(field.value) ? field.value : ""}
          type="number"
          min={min}
          max={max}
          step={step}
          size="mini"
          label={{ content: "GB", basic: true }}
          labelPosition="right"
          className="formik-slider-number-input"
        />
        <FormikAPIErrorMessage name={field.name} apiErrors={apiErrors} />
      </Fragment>
    );
  }
}

export default FormikSemanticSlider;
